import type { Message } from "../api";

interface Props {
  message: Message;
  meId: string;
}

/** Affiche les coches "remis / lu" sur ses propres messages destinés à un user précis.
 * - 0 coche : pas encore remis (livraison différée hors plage)
 * - ✓     : remis (delivered_at posé)
 * - ✓✓ gris : remis mais pas encore lu (lu = read_at posé par intersection observer)
 * - ✓✓ bleu : lu
 * - "✓ traité" : badge texte séparé (état métier)
 *
 * Sur les messages "à tous" (recipient_user_id NULL), on n'affiche pas de coches. */
export default function MessageTicks({ message, meId }: Props) {
  const mine = message.user_id === meId;
  const targeted = !!message.recipient_user_id;
  if (!mine || !targeted) return null;

  const delivered = !!message.delivered_at;
  const read = !!message.read_at;

  if (!delivered) return <span className="ticks pending" title="En attente de remise">⏱</span>;

  // 1 ou 2 coches selon l'état
  return (
    <span className={`ticks ${read ? "read" : "delivered"}`} title={read ? "Lu" : "Remis"}>
      <Tick />
      {read && <Tick />}
    </span>
  );
}

function Tick() {
  return (
    <svg viewBox="0 0 16 12" width="14" height="10" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M2 6.5L6 10.5L14 1.5" />
    </svg>
  );
}
